<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="800px">
      <v-card>
        <v-card-title class="primary">
          <span style="color: #fff" class="text-h5">Exportar Aula</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <ValidationObserver v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(enableSubmit)" :disabled="false">
                <v-row>
                  <v-col class="pt-2 pb-0" cols="12">
                    <ValidationProvider name="Turma" rules="required" v-slot="{ errors }">
                      <e-label class="font-weight-medium">Turma</e-label>
                      <p class="font-weight-regular">
                        <v-select
                          :items="turmas"
                          item-text="turma.descricao"
                          item-value="turma.id"
                          :hint="`${turmaSelecionada.turma.franquia.descricao}`"
                          return-object
                          label="Selecione o campo abaixo"
                          v-model="turmaSelecionada"
                          :error-messages="errors"
                        ></v-select>
                      </p>
                    </ValidationProvider>
                  </v-col>
                  <v-col class="pt-0 pb-0" :cols="12" :lg="2">
                    <e-label class="font-weight-medium">Tipo de Aula</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.tipo_de_aula }}
                    </p>
                  </v-col>

                  <v-col class="pt-0 pb-0" :cols="12" :lg="5">
                    <v-dialog ref="dialog" v-model="modal" :return-value.sync="date" width="290px">
                      <template v-slot:activator="{ on, attrs }">
                        <e-label>Selecione uma data</e-label>
                        <v-text-field
                          dense
                          solo
                          v-model="data_aula"
                          label="data"
                          v-bind="attrs"
                          v-on="on"
                        ></v-text-field>
                      </template>

                      <v-date-picker color="primary" v-model="dataAulaDuplicada" scrollable>
                        <v-spacer></v-spacer>
                        <v-btn text color="primary" @click="modal = false"> Cancel </v-btn>
                        <v-btn text color="primary" @click="$refs.dialog.save(date)"> OK </v-btn>
                      </v-date-picker>
                    </v-dialog>
                  </v-col>

                  <v-col
                    class="pt-0 pb-0"
                    :cols="12"
                    :lg="5"
                    v-if="gestaoDeAula.tipo_de_aula !== 'Aula Remota'"
                  >
                    <ValidationProvider name="Horário da aula" rules="required" v-slot="{ errors }">
                      <e-label>Selecione um horário</e-label>
                      <e-autocomplete
                        :items="horarios"
                        :error-messages="errors"
                        label="Selecione uma opção"
                        :item-text="(item) => item.descricao"
                        v-model="horarioSelecionado"
                        return-object
                        dense
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="barra-rolagem-vertical">
                    <e-label class="font-weight-medium">Conteúdo</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.conteudo }}
                    </p>
                  </v-col>
                  <v-col cols="12" class="barra-rolagem-vertical">
                    <e-label class="font-weight-medium">Metodologia</e-label>
                    <p class="font-weight-regular">
                      {{ gestaoDeAula.metodologia }}
                    </p>
                  </v-col>
                </v-row>
                <v-divider class="my-6"></v-divider>
                <e-progresso-preenchimento
                  :expectedItems="itemsEsperados"
                  :filledItems="itemsPreenchidos"
                  @total-filled-changed="
                    (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                  "
                />
                <v-card-actions>
                  <v-btn
                    style="color: #fff"
                    class="red darken-1"
                    @click="$emit('dialogChange', false)"
                  >
                    Fechar
                  </v-btn>
                  <v-btn
                    style="color: #fff"
                    class="green darken-1"
                    type="submit"
                    :disabled="!totalmentePreenchido"
                  >
                    Salvar
                  </v-btn>
                </v-card-actions>
              </form>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="exportarAula"
    >
    </e-modal-confirm>
  </v-row>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
  },
  data() {
    return {
      dataAulaDuplicada: null,
      modal: false,
      menu: false,
      gestaoDeAula: {},
      data_aula: null,
      confirmDialog: false,
      turmas: [],
      turmaSelecionada: {
        turma: {
          id: null,
          franquia: {
            descricao: "",
            fantasia: "",
          },
        },
      },
      objectModal: {
        title: "Exportar aula",
        message: "Tem certeza que deseja exportar esta aula?",
      },
      horarios: [],
      horarioSelecionado: null,
      itemsEsperados: [
        { label: "Turma", value: "turmaSelecionada" },
        { label: "Data", value: "dataAulaDuplicada" },
        { label: "Horário", value: "horarioSelecionado" },
      ],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
    };
  },
  created() {
    // Cria um watcher para cada item esperado (value).
    this.itemsEsperados.forEach((item) => {
      this.$watch(item.value, (val) => {
        this.$toggleItemPreenchidoBarraProgresso(item.value, val, this.itemsPreenchidos);
      });
    });
  },
  watch: {
    form: {
      immediate: true,
      handler(val) {
        this.gestaoDeAula = val;
      },
    },
    turmaSelecionada: {
      immediate: true,
      handler(val) {
        this.horarios = val.turma.horarios;
      },
    },
    dialog: {
      async handler(val) {
        if (val) {
          this.$loaderService.open("Carregando gestões de aula");
          try {
            const gestoes = await this.$services.gestoesDeAulasService.listarGestoesProfessor(
              this.gestaoDeAula
            );
            this.turmas = gestoes;
          } catch (error) {
            this.$handleError(error);
          } finally {
            this.$loaderService.close();
          }
        }
      },
    },
    dataAulaDuplicada(value) {
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data_aula = data_old.replaceAll("/", "/");
    },
  },
  methods: {
    enableSubmit() {
      if (
        !this.turmaSelecionada?.turma?.id ||
        !this.dataAulaDuplicada ||
        !this.horarioSelecionado?.id
      ) {
        this.$toast.danger("Preencha todos os campos obrigatórios: turma, data e horário.");
        return;
      }
      this.confirmDialog = !this.confirmDialog;
      this.gestaoDeAula.data = this.dataAulaDuplicada;
    },
    async exportarAula() {
      this.$loaderService.open("Exportando a Aula");
      try {
        this.gestaoDeAula.horario_inicial = this.horarioSelecionado
          ? this.horarioSelecionado.inicio
          : null;
        this.gestaoDeAula.horario_final = this.horarioSelecionado
          ? this.horarioSelecionado.final
          : null;
        this.gestaoDeAula.horario_id = this.horarioSelecionado ? this.horarioSelecionado.id : null;
        this.gestaoDeAula.instrutorDisciplinaTurma_id = parseInt(this.turmaSelecionada.id, 10);
        this.gestaoDeAula.turma_id = this.turmaSelecionada.turma.id;
        this.confirmDialog = !this.confirmDialog;

        this.$emit("dialogChange", false);
        await this.$services.aulasService.criar(this.gestaoDeAula);

        this.$toast.success("Aula exportada com sucesso!");
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>
<style>
.barra-rolagem-vertical {
  max-height: 150px;
  overflow-y: auto;
}
</style>
